import axios from "axios";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const teamMemberApiUrl = `${baseApiUrl}/api/TeamMember`;

export async function getTeamMembers(name, projectid) {
  return await httpRequest(fetchTeamMembers.bind(this, name, projectid));
}
async function fetchTeamMembers(name, projectid) {
  let config = getHttpHeaders();
  return await axios.get(
    `${teamMemberApiUrl}?Name=${name}&ProjetId=${projectid}`,
    config
  );
}

export async function addTeamMember(newTeamMember) {
  return await httpRequest(postTeamMembers.bind(this, newTeamMember));
}
async function postTeamMembers(newTeamMember) {
  let config = getHttpHeaders();
  return await axios.post(`${teamMemberApiUrl}`, newTeamMember, config);
}

export async function deleteTeamMember(id) {
  return await httpRequest(fetchDeleteTeamMember.bind(this, id));
}
async function fetchDeleteTeamMember(id) {
  let config = getHttpHeaders();
  return await axios.delete(`${teamMemberApiUrl}/${id}`, config);
}
